import { duration } from 'moment';
import { DayOfWeek } from 'core/day-of-week';
import { minsToHours } from '../financials/utils/common';
export const MINUTES_IN_A_DAY = 1440; // 24 * 60
export const DEFAULT_CAPACITY_MINUTES_PER_DAY = 480; // 8h per day
export const DEFAULT_CAPACITY_MINUTES_PER_WEEK = 2400; // 40 h/week
export const MAX_CAPACITY_MINUTES_FOR_A_WEEK = duration(24, 'hours').asMinutes() * 7; // TODO: Check with PM if we need to do capacity * 7 or capacity * noOfWorkingDays?
export const DefaultWorkingDayConfig = {
    [DayOfWeek.Monday]: true,
    [DayOfWeek.Tuesday]: true,
    [DayOfWeek.Wednesday]: true,
    [DayOfWeek.Thursday]: true,
    [DayOfWeek.Friday]: true,
    [DayOfWeek.Saturday]: false,
    [DayOfWeek.Sunday]: false
};
export const getNumberOfWorkingDaysInAWeek = (workingDaysConfig = DefaultWorkingDayConfig)=>Object.values(workingDaysConfig).filter(Boolean).length;
export const getCapacityInMinutesForADay = (capacityMinutes, workingDays = DefaultWorkingDayConfig)=>{
    const numberOfWorkingDays = getNumberOfWorkingDaysInAWeek(workingDays);
    return Math.floor(capacityMinutes / numberOfWorkingDays);
};
export const getCapacityInHoursForADay = (capacityMinutes, workingDays = DefaultWorkingDayConfig)=>{
    return minsToHours(getCapacityInMinutesForADay(capacityMinutes, workingDays));
};
export const userCapacityFormValidator = (value, translate, onResolve, onReject)=>{
    if (value <= 0 || value > MAX_CAPACITY_MINUTES_FOR_A_WEEK) {
        onReject === null || onReject === void 0 ? void 0 : onReject();
        return Promise.reject(new Error(translate('settings.weekly_capacity.input.error')));
    }
    onResolve === null || onResolve === void 0 ? void 0 : onResolve();
    return Promise.resolve();
};
export const validateAndRoundOffInputDuration = (value, workingDaysConfig = DefaultWorkingDayConfig)=>{
    const numberOfWorkingDays = getNumberOfWorkingDaysInAWeek(workingDaysConfig);
    return Math.round(value / numberOfWorkingDays) * numberOfWorkingDays;
};
